export default __webpack_public_path__ + "static/avatar-2-05aa32a013a0302f1a80ce5fa8f8bcf6.jpg";